import { Flex } from '@sequencehq/core-components'
import { useAtomValue } from 'jotai'
import {
  ButtonClose,
  ButtonDownloadPdf,
  ButtonTogglePreview
} from 'Invoices/components/CreateEditShared/Header'
import { invoiceCustomerIdAtom } from 'Invoices/atoms/invoiceEditing.atom'

export const HeaderActions = () => {
  const customerId = useAtomValue(invoiceCustomerIdAtom)

  return (
    <Flex gap="8px">
      {customerId && <ButtonDownloadPdf />}
      <ButtonTogglePreview />
      <ButtonClose />
    </Flex>
  )
}
